var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noneImg"},[_c('img',{attrs:{"src":require("@/assets/empty.png")}}),_c('span',[_vm._v("当前暂无数据")])])}]

export { render, staticRenderFns }